import { HttpClient, createHttpGetOptions } from "../../../services/http/http-client";
import { HttpLib } from "../../../services/http/http-lib";
import { MODIFICATION_URL } from "../../../services/common-urls";
import { BOOKING_URL, CONTACTS_URL, CALENDAR_DATES_STRING } from "./booking-service";

const SECTION_BOOKING_REPORTS = 'reports';

export const bookingReportsService = {

    getBookingReportsArtistReport: () => {
        return HttpClient.get(BOOKING_URL, {
            section: SECTION_BOOKING_REPORTS
        });
    },

    getBookingReportVenues: () => {
        return HttpClient.get(BOOKING_URL, {
            section: SECTION_BOOKING_REPORTS,
            action: 'location_list'
        });
    },

    getBookingReportVenueSearch: (searchKey) => {
        return HttpClient.get(BOOKING_URL, {
            section: SECTION_BOOKING_REPORTS,
            action: 'search_location',
            search: searchKey
        });
    },

    getBookingReportPromoters: () => {
        return HttpClient.get(BOOKING_URL, {
            section: SECTION_BOOKING_REPORTS,
            action: 'promoter_list'
        });
    },

    getBookingReportPromoterSearch: (searchKey) => {
        return HttpClient.get(BOOKING_URL, {
            section: SECTION_BOOKING_REPORTS,
            action: 'search_promoter',
            search: searchKey
        });
    },

    getBookingReportGenerate: (reportParams) => {
        return HttpClient.get(BOOKING_URL, {
            section: SECTION_BOOKING_REPORTS,
            action: 'booking_report',
            ...reportParams
        }, createHttpGetOptions({
            qsStringifyArrayFormat: 'repeat',
            responseType: 'blob'
        }));
    }
};